import React, { useState } from 'react';
import FunnelStageGraph from 'src/components/recruiterCandidatesGraph/FunnelStageGraph';
import SalaryMatchGraph from 'src/components/recruiterCandidatesGraph/SalaryMatchGraph';
import SkillsMatchGraph from 'src/components/recruiterCandidatesGraph/SkillsMatchGraph';
import HiringAssessmentCandidatesHeader from './HiringAssessmentCandidatesHeader';
import Container from 'src/components/shared/Container';
import HiringAssessmentGraphTabs, { HiringAssessmentGraphTabsEnum } from './HiringAssessmentGraphTabs';

import Select, { SingleValue } from 'react-select';
import { RiPieChartFill } from 'react-icons/ri';
import { GiHamburgerMenu } from 'react-icons/gi';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

const HiringAssessmentGraph = () => {
	const { id: hiringAssessmentId } = useParams();
	const [searchParams, setSearchParams] = useSearchParams();
	const [activeTab, setActiveTab] = useState<HiringAssessmentGraphTabsEnum>(
		(searchParams.get('tab') as HiringAssessmentGraphTabsEnum) || HiringAssessmentGraphTabsEnum.FUNNEL,
	);
	const navigate = useNavigate();

	// Define the options type and options array
	type OptionType = { value: number; label: string };
	const options: OptionType[] = [
		{ value: 10, label: 'Top 10' },
		{ value: 20, label: 'Top 20' },
		{ value: 50, label: 'Top 50' },
	];

	const handleChange = (selectedOption: SingleValue<OptionType>) => {
		searchParams.set('top', selectedOption?.value?.toString() ?? '1');
		setSearchParams(searchParams);
	};
	const handleUserList = () => {
		navigate(`/recruiter-dashboard/hiring-assessment-list/${hiringAssessmentId}`);
	};
	const handleUsersGraph = () => {
		navigate(`/recruiter-dashboard/hiring-assessment-graph/${hiringAssessmentId}`);
	};
	const handleAssessmentChange = (id: string) => {
		navigate(`/recruiter-dashboard/hiring-assessment-graph/${id}`);
	};

	return (
		<Container>
			<div className="flex justify-between items-center border-b border-[#EBEBF0] dark:border-[#555770] border-solid">
				<div>
					<HiringAssessmentCandidatesHeader onClick={handleAssessmentChange} />
				</div>
				<div className="inline-flex w-[84px] h-[32px] rounded-md border border-[#E4E4EB] bg-white shadow-sm overflow-hidden mt-[24px]">
					<button
						onClick={handleUsersGraph}
						className="flex items-center justify-center w-1/2 h-full border-r border-[#E4E4EB] transition-colors hover:bg-gray-50 focus:outline-none "
						aria-label="View chart"
					>
						<RiPieChartFill className="h-4 w-4 text-slate-600" />
					</button>
					<button
						onClick={handleUserList}
						className="flex items-center justify-center w-1/2 h-full transition-colors hover:bg-gray-50 focus:outline-none "
						aria-label="Open menu"
					>
						<GiHamburgerMenu className="h-4 w-4 text-slate-600" />
					</button>
				</div>
			</div>
			<div className="mx-auto flex gap-2 flex-col tlg:flex-row items-end justify-between mt-4">
				<HiringAssessmentGraphTabs
					tab={activeTab}
					setTab={setActiveTab}
					onChange={e => {
						searchParams.set('tab', e);
						setSearchParams(searchParams);
					}}
					totalConections={0}
					isTourActive={false}
				/>
				{activeTab !== HiringAssessmentGraphTabsEnum.FUNNEL && (
					<div className="w-full tlg:w-auto whiteBgSelect">
						<Select
							menuPlacement={'auto'}
							isSearchable={false}
							classNamePrefix="my-select-plans"
							closeMenuOnSelect
							options={options}
							defaultValue={options[0]}
							value={options.find(option => option.value === Number(searchParams.get('top')))}
							onChange={handleChange}
						/>
					</div>
				)}
			</div>
			<div className="mt-4 mx-auto pb-4">
				{activeTab === HiringAssessmentGraphTabsEnum.FUNNEL && <FunnelStageGraph />}
				{activeTab === HiringAssessmentGraphTabsEnum.MATCH && <SkillsMatchGraph />}
				{activeTab === HiringAssessmentGraphTabsEnum.SALARY && <SalaryMatchGraph />}
			</div>
		</Container>
	);
};

export default HiringAssessmentGraph;
